let seq = 0;

/** Unique news feed keys even when many items are added in one tick */
export function nextNewsId(): string {
  seq += 1;
  return `${Date.now()}-${seq}`;
}